module.exports = __webpack_public_path__ + "img/ava-1.280ddcde.png";